import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'aff-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {
  @Input() title: String = '';
  @Input() link: String = '';
  @Input() bodyContent: String = '';
  @Input() page: String='';

  constructor() { }

  ngOnInit() {
    console.log(this.page);
  }

  styleObject(): Object {
       if (this.page==='campaignPage' ){
           return {"background-color": "#f6f5fa"}
       }
       return {}
   }

}
